import { render } from "./ShowTemplateMainRep.vue?vue&type=template&id=2ad428ae"
import script from "./ShowTemplateMainRep.vue?vue&type=script&lang=js"
export * from "./ShowTemplateMainRep.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/views/customer/reporting/container/show_template_main_rep.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fviews%2Fcustomer%2Freporting%2Fcontainer%2FShowTemplateMainRep.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__